import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
export interface LoadingPropsType extends GeneralPropsType {
  rootClassName?: string;
}
function Loading({
  children,
  className,
  rootClassName
}: LoadingPropsType) {
  return <div className={clsx({
    "fixed inset-0 z-[999999] bg-black text-secondary flex items-center justify-center": true,
    [styles.container]: true,
    className: true
  }, rootClassName)} data-sentry-component="Loading" data-sentry-source-file="index.tsx">
            <svg viewBox="0 0 960 200" className={styles.svg} data-sentry-element="svg" data-sentry-source-file="index.tsx">
                <symbol id="s-text" data-sentry-element="symbol" data-sentry-source-file="index.tsx">
                    <text textAnchor="middle" x="50%" y="80%" data-sentry-element="text" data-sentry-source-file="index.tsx">
                        TBK
                    </text>
                </symbol>
                <g className="g-ants" data-sentry-element="g" data-sentry-source-file="index.tsx">
                    <use href="#s-text" className={styles["text-copy"]} data-sentry-element="use" data-sentry-source-file="index.tsx"></use>
                    <use href="#s-text" className={styles["text-copy"]} data-sentry-element="use" data-sentry-source-file="index.tsx"></use>
                    <use href="#s-text" className={styles["text-copy"]} data-sentry-element="use" data-sentry-source-file="index.tsx"></use>
                    <use href="#s-text" className={styles["text-copy"]} data-sentry-element="use" data-sentry-source-file="index.tsx"></use>
                    <use href="#s-text" className={styles["text-copy"]} data-sentry-element="use" data-sentry-source-file="index.tsx"></use>
                </g>
            </svg>
        </div>;
}
export default Loading;